/* DeSiM 公式店 — 目的地一覧ページ（sections/destinations-index.liquid）専用 JS。
   サーバー検索は無い（brief 指示）。やること:
     1. URL の ?q= / ?days= を検索欄へ反映する（Task 6 のヒーロー検索がここへ GET する）。
     2. 地域タブ + 検索語でカード/行を絞り込む（data-region / data-name 属性を見るだけ）。
     3. 絞り込み中は「さらに表示」で畳んでいた行も含めて全部見せる（検索結果が
        1グループ目に無ければ永遠に見つからないため）。
     4. 該当 0 件になった「人気の目的地」は見出しごと隠す（空白だけが残ると
        結果が消えたように見える）。
     5. 「検索」ボタン / キーボードの確定キーで submit されたら、再読込せずに
        キーボードを閉じて結果へスクロールする。
     6. 地域タブを選んだとき、その地域を覆う周遊（data-region-2）を
        「複数国を移動する方へ」ブロックに出す（spec 2026-09-09 / 対話 184370）。
        🔴 このブロックの行は `rows` に**混ぜない**。混ぜると data-region="multi" が
           無いので既存判定から漏れ、地域タブで隠されてブロックが常に空になる。
   絞り込みは表示/非表示の切り替えのみ。DOM 構造やリンク先は変えない。 */
(function () {
  var root = document.querySelector('[data-ds-dest-search]');
  if (!root) return;

  var qInput = document.querySelector('[data-ds-dest-q]');
  var daysSelect = document.querySelector('[data-ds-dest-days]');
  var tabsWrap = document.querySelector('[data-ds-dest-tabs]');
  var tabs = tabsWrap ? Array.prototype.slice.call(tabsWrap.querySelectorAll('[data-region]')) : [];
  var moreBtn = document.querySelector('[data-ds-dest-more]');
  var kanaGroups = Array.prototype.slice.call(
    document.querySelectorAll('[data-ds-dest-kana-group]'),
  );
  var cards = Array.prototype.slice.call(
    document.querySelectorAll('[data-ds-dest-popular] [data-region]'),
  );
  // 🔴 `:not([data-region-2])` で新ブロックの行を除外する。
  //    これを外すと新ブロックの行も data-region（無い）で判定され、常に隠れる。
  var rows = Array.prototype.slice.call(
    document.querySelectorAll('.ds-dest-row:not([data-region-2])'),
  );
  var roamingBlock = document.querySelector('[data-ds-dest-roaming]');
  var roamingRows = Array.prototype.slice.call(
    document.querySelectorAll('.ds-dest-row[data-region-2]'),
  );
  var items = cards.concat(rows);
  var linkables = items.concat(roamingRows);
  var popularSection = document.querySelector('[data-ds-dest-popular-section]');
  var resultsSection = document.querySelector('[data-ds-dest-results]');

  var activeRegion = 'all';

  function normalize(s) {
    return (s || '').toString().toLowerCase().trim();
  }

  function applyFilter() {
    var q = normalize(qInput ? qInput.value : '');
    var filtering = q !== '' || activeRegion !== 'all';

    // 周遊ブロック: 地域タブを選んだときだけ、その地域を覆う周遊を出す。
    // 🔴 `data-region-2` の値域は europe|asia なので、all / multi / americas /
    //    oceania-mideast では自動的に 0 件になる。`all` の特別扱いは要らない。
    if (roamingBlock) {
      var visibleRoaming = 0;
      roamingRows.forEach(function (el) {
        var ok =
          el.getAttribute('data-region-2') === activeRegion &&
          (q === '' || normalize(el.getAttribute('data-name')).indexOf(q) !== -1);
        el.classList.toggle('is-hidden', !ok);
        if (ok) visibleRoaming++;
      });
      roamingBlock.hidden = visibleRoaming === 0;
    }

    items.forEach(function (el) {
      var matchesRegion = activeRegion === 'all' || el.getAttribute('data-region') === activeRegion;
      var matchesQuery = q === '' || normalize(el.getAttribute('data-name')).indexOf(q) !== -1;
      el.classList.toggle('is-hidden', !(matchesRegion && matchesQuery));
    });

    // 絞り込み中は五十音グループの初期折りたたみを解除し、
    // 該当が 0 件のグループ見出しごと隠す。絞り込み解除で元の折りたたみへ戻す。
    kanaGroups.forEach(function (group, i) {
      var visibleRows = Array.prototype.slice
        .call(group.querySelectorAll('.ds-dest-row'))
        .filter(function (r) {
          return !r.classList.contains('is-hidden');
        });
      group.classList.toggle('is-empty', filtering && visibleRows.length === 0);
      if (filtering) {
        group.classList.remove('is-hidden-initial');
      } else if (i > 0) {
        group.classList.add('is-hidden-initial');
      }
    });

    // 絞り込みで「人気の目的地」が全部消えたら、見出しごと隠す。
    // 見出しだけ残ると空白の帯になり、検索が壊れたように見える。
    if (popularSection) {
      var visibleCards = cards.filter(function (c) {
        return !c.classList.contains('is-hidden');
      });
      popularSection.classList.toggle('is-empty', filtering && visibleCards.length === 0);
    }

    if (moreBtn) moreBtn.classList.toggle('is-hidden', filtering);
  }

  if (qInput) qInput.addEventListener('input', applyFilter);

  /* 「検索」ボタン（およびソフトキーボードの確定キー）。絞り込み自体は入力のたびに
     済んでいるので、ここでやるのは「キーボードを閉じて結果を見せる」こと。
     🔴 preventDefault しないと GET で再読込が走り、SP の細い回線では 1〜2 秒
     真っ白になる。JS が動かない環境では素の GET として成立するので、
     ボタンは type="submit" のまま残してある。 */
  root.addEventListener('submit', function (e) {
    e.preventDefault();
    applyFilter();
    if (qInput) qInput.blur();
    var target = resultsSection;
    if (popularSection && !popularSection.classList.contains('is-empty')) {
      target = popularSection;
    }
    if (target && target.scrollIntoView) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-pressed', 'false');
      });
      tab.classList.add('is-active');
      tab.setAttribute('aria-pressed', 'true');
      activeRegion = tab.getAttribute('data-region') || 'all';
      applyFilter();
    });
  });

  if (moreBtn) {
    moreBtn.addEventListener('click', function () {
      kanaGroups.forEach(function (g) {
        g.classList.remove('is-hidden-initial');
      });
      moreBtn.classList.add('is-hidden');
    });
  }

  // ?days= を各カード/行のリンクへ引き継ぐ（商品ページ側の受け口は将来対応）。
  function appendDaysParam(days) {
    if (!days) return;
    linkables.forEach(function (el) {
      var href = el.getAttribute('href');
      if (!href || href.indexOf('days=') !== -1) return;
      var sep = href.indexOf('?') === -1 ? '?' : '&';
      el.setAttribute('href', href + sep + 'days=' + encodeURIComponent(days));
    });
  }

  /* 「日数」セレクタで金額表示を差し替える。
     🔴 2026-09-17 運営指摘「日数で検索しても全部表記の金額が同じになる」。
        それまで days は**リンクに ?days= を足すだけ**で、行の金額は常に
        `custom.min_price_label`（＝目的地の全 variant の最安）だった。
        既定で「7日間」が選ばれているのに「最安 ¥110〜」が並ぶので、
        7 日の旅行が ¥110 でできるように読めてしまう。
     値は collection メタフィールド `custom.price_by_days`（scripts/
     refresh-desim-dest-price-meta.ts が生成）。**その日数以上を賄える最安**なので
     日数に対して単調非減少。該当が無い目的地は元の「最安」表示のまま残す
     （金額欄を空にすると壊れて見える）。 */
  var priceHosts = Array.prototype.slice.call(document.querySelectorAll('[data-prices]'));

  function parsePrices(el) {
    if (el.__dsPrices !== undefined) return el.__dsPrices;
    var raw = el.getAttribute('data-prices');
    try {
      el.__dsPrices = raw ? JSON.parse(raw) : null;
    } catch (e) {
      el.__dsPrices = null;
    }
    return el.__dsPrices;
  }

  function priceParts(el) {
    var daysEl = el.querySelector('.ds-dest-row__price-days, .ds-dest-card__price-days');
    var valueEl = el.querySelector('.ds-dest-row__price-value, .ds-dest-card__price-value');
    if (!valueEl) return null;
    if (!el.__dsPriceBase) {
      el.__dsPriceBase = {
        days: daysEl ? daysEl.textContent : '',
        value: valueEl.textContent,
      };
    }
    return { daysEl: daysEl, valueEl: valueEl, base: el.__dsPriceBase };
  }

  function applyDaysPrice() {
    var days = daysSelect ? daysSelect.value : '';
    priceHosts.forEach(function (el) {
      var parts = priceParts(el);
      if (!parts) return;
      var prices = parsePrices(el);
      var amount = days && prices ? prices[days] : null;
      if (amount == null) {
        if (parts.daysEl) parts.daysEl.textContent = parts.base.days;
        parts.valueEl.textContent = parts.base.value;
        return;
      }
      if (parts.daysEl) parts.daysEl.textContent = daysLabel(days);
      parts.valueEl.textContent = formatPrice(parts.base.value, amount);
    });
  }

  /* 文言は JS に持たない（多言語化）。日数の表記は Liquid が訳して描いた
     <option> の文字（ja「7日間」/ en「7 days」）をそのまま使う。 */
  function daysLabel(days) {
    if (!daysSelect) return days;
    for (var i = 0; i < daysSelect.options.length; i++) {
      if (daysSelect.options[i].value === days) return daysSelect.options[i].text;
    }
    return days;
  }

  /* 金額の前後の書式（ja は末尾「〜」、en は無し）も Liquid が訳して描いた元の表示
     （例 ja「¥110〜」/ en「¥110」）から取る: 元の金額部分だけを新しい金額に差し替える。
     元の表示に金額が見つからなければ金額だけを出す。 */
  function formatPrice(baseText, amount) {
    var money = '¥' + Number(amount).toLocaleString('ja-JP');
    var re = /[¥￥]\s*[\d,]+/;
    return re.test(baseText || '') ? baseText.replace(re, money) : money;
  }

  if (daysSelect) {
    daysSelect.addEventListener('change', function () {
      applyDaysPrice();
      // リンク側の ?days= も選び直しに追従させる（初回だけ足して放置しない）。
      var days = daysSelect.value;
      linkables.forEach(function (el) {
        var href = (el.getAttribute('href') || '')
          .replace(/([?&])days=[^&]*/, '$1')
          .replace(/[?&]$/, '');
        if (!days) {
          el.setAttribute('href', href);
          return;
        }
        var sep = href.indexOf('?') === -1 ? '?' : '&';
        el.setAttribute('href', href + sep + 'days=' + encodeURIComponent(days));
      });
    });
  }

  var params = new URLSearchParams(window.location.search);
  var qParam = params.get('q');
  var daysParam = params.get('days');
  if (qParam && qInput) qInput.value = qParam;
  if (daysParam && daysSelect) {
    var hasOption = Array.prototype.some.call(daysSelect.options, function (opt) {
      return opt.value === daysParam;
    });
    if (hasOption) daysSelect.value = daysParam;
  }
  if (qParam) applyFilter();
  appendDaysParam(daysParam);
  // 既定で「7日間」が選ばれているので、読み込み時点から金額をその日数に合わせる。
  applyDaysPrice();
})();
